import useSelectSessionCrew from '../helpers/use-select-session-crew';
import AddCrewModal from './add-crew-modal/add-crew-modal';

const CrewHeaderActions = () => {
  const crew = useSelectSessionCrew();

  if (!crew?.length) return null;
  return (
    <div>
      <AddCrewModal buttonSize="small" />
    </div>
  );
};

export default CrewHeaderActions;
